<div class="modal--wrapper">
  <h3>{{ 'MODALS.POST_DELETE.TITLE' | translate }}</h3>
  <p>{{ 'MODALS.POST_DELETE.DESCRIPTION' | translate }}</p>
  <ark-button type="negative" (click)="submit()">
    {{ 'MODALS.POST_DELETE.PRIMARY_CTA' | translate }}</ark-button
  >
  <a (click)="cancel()">{{ 'MODALS.POST_DELETE.SECONDARY_CTA' | translate }}</a>
</div>
